import React from 'react';
import { slideWrapper } from '../components/slide';
import { RoundLetters, RoundType } from '@disco/data';
import { PuzzleItems } from '../components/puzzle-items';

import { Content } from '../components/content';
import { SlideImage } from '../components/slide-image';

export const LeonardoPuzzle2Counting = slideWrapper(
  ({ step, getImg, countingResults, countingResultsLoading }) => {
    const { answers } = step;

    return (
      <>
        <Content left={15} top={20} yNotCenter>
          <SlideImage width="400px" src={getImg('balon-color')} show={true} />
        </Content>
        <PuzzleItems
          {...{ countingResults, countingResultsLoading, getImg, answers, letters: RoundLetters[5] }}
          smallItem
        />
      </>
    );
  },
  { countAnswersTour: RoundType.Leonardo }
);
